import React from "react";

interface CompleteIllustratorIconProps {
  width?: number;
  height?: number;
}

const CompleteIllustratorIcon: React.FC<CompleteIllustratorIconProps> = ({
  width = 68,
  height = 49,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 68 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M54.1025 24.418C54.1025 35.0009 45.5591 43.5801 35.0202 43.5801C24.4814 43.5801 15.938 35.0009 15.938 24.418C15.938 13.835 24.4814 5.25586 35.0202 5.25586C45.5591 5.25586 54.1025 13.835 54.1025 24.418Z"
        fill="#BCD0BF"
      />
      <path
        d="M29.4757 35.2664L18.5973 24.4958C18.5692 24.4681 18.5889 24.4203 18.6283 24.4203C18.6399 24.4203 18.6511 24.4157 18.6594 24.4075L22.5755 20.5302C22.6924 20.4145 22.8781 20.4119 22.9946 20.528C24.6656 22.1945 29.6871 27.304 29.6871 27.304L43.5271 13.5746C43.644 13.4587 43.8324 13.4586 43.9494 13.5744L47.663 17.2511C47.7815 17.3685 47.7815 17.5601 47.663 17.6775L42.3184 22.9691L29.8979 35.2664C29.781 35.3821 29.5926 35.3821 29.4757 35.2664Z"
        fill="white"
      />
      <path
        d="M56.4483 45.5934L58.6352 47.8174L67.7633 38.9214L65.9567 37.0842C65.2911 36.4074 64.8157 35.6338 64.5304 34.7636L63.7697 32.5396C63.3894 31.4759 62.8189 30.509 62.0582 29.7354L58.0647 25.6742C57.2089 24.9006 55.8777 24.7073 55.022 25.3841C54.4515 25.7709 54.0711 26.4478 54.0711 27.2213C53.5006 27.1246 52.835 27.2213 52.3596 27.6081C51.7891 28.0916 51.4088 28.6718 51.4088 29.3486C50.7432 29.2519 50.0776 29.3486 49.6022 29.7354C49.2218 30.0255 48.8415 30.509 48.7464 30.9924L43.0262 25.0968C42.5508 24.6133 41.8852 24.4199 41.2196 24.4199C40.554 24.5166 39.8884 24.8067 39.5081 25.3869C38.8425 26.3538 38.9376 27.6109 39.7933 28.4811L44.7529 33.6032C44.1823 33.6999 43.6118 34.0867 43.2315 34.6669C42.5659 35.7305 42.7561 37.0842 43.7069 38.0512L49.0317 43.4661C49.7923 44.3364 50.8383 44.8198 51.9793 44.8198H54.7367C55.4023 44.8198 56.4483 45.5934 56.4483 45.5934Z"
        fill="#F2F0EC"
      />
      <path
        d="M36.7585 29.2101L29.8979 36.0027C29.781 36.1184 29.5926 36.1184 29.4757 36.0027L18.5973 25.2321C18.5692 25.2044 18.5889 25.1566 18.6283 25.1566V25.1566C18.6399 25.1566 18.6511 25.152 18.6594 25.1438L22.5755 21.2665C22.6924 21.1508 22.8781 21.1482 22.9946 21.2644C24.6656 22.9308 29.6871 28.0403 29.6871 28.0403L43.5271 14.3109C43.644 14.195 43.8324 14.1949 43.9494 14.3107L47.663 17.9874C47.7815 18.1048 47.7815 18.2964 47.663 18.4138L42.3184 23.7054"
        stroke="#1A1A1A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M36.7585 29.2101L29.8979 36.0027C29.781 36.1184 29.5926 36.1184 29.4757 36.0027L18.5973 25.2321C18.5692 25.2044 18.5889 25.1566 18.6283 25.1566V25.1566C18.6399 25.1566 18.6511 25.152 18.6594 25.1438L22.5755 21.2665C22.6924 21.1508 22.8781 21.1482 22.9946 21.2644C24.6656 22.9308 29.6871 28.0403 29.6871 28.0403L43.5271 14.3109C43.644 14.195 43.8324 14.1949 43.9494 14.3107L47.663 17.9874C47.7815 18.1048 47.7815 18.2964 47.663 18.4138L42.3184 23.7054"
        stroke="black"
        stroke-opacity="0.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M36.7585 29.2101L29.8979 36.0027C29.781 36.1184 29.5926 36.1184 29.4757 36.0027L18.5973 25.2321C18.5692 25.2044 18.5889 25.1566 18.6283 25.1566V25.1566C18.6399 25.1566 18.6511 25.152 18.6594 25.1438L22.5755 21.2665C22.6924 21.1508 22.8781 21.1482 22.9946 21.2644C24.6656 22.9308 29.6871 28.0403 29.6871 28.0403L43.5271 14.3109C43.644 14.195 43.8324 14.1949 43.9494 14.3107L47.663 17.9874C47.7815 18.1048 47.7815 18.2964 47.663 18.4138L42.3184 23.7054"
        stroke="black"
        stroke-opacity="0.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M36.7585 29.2101L29.8979 36.0027C29.781 36.1184 29.5926 36.1184 29.4757 36.0027L18.5973 25.2321C18.5692 25.2044 18.5889 25.1566 18.6283 25.1566V25.1566C18.6399 25.1566 18.6511 25.152 18.6594 25.1438L22.5755 21.2665C22.6924 21.1508 22.8781 21.1482 22.9946 21.2644C24.6656 22.9308 29.6871 28.0403 29.6871 28.0403L43.5271 14.3109C43.644 14.195 43.8324 14.1949 43.9494 14.3107L47.663 17.9874C47.7815 18.1048 47.7815 18.2964 47.663 18.4138L42.3184 23.7054"
        stroke="black"
        stroke-opacity="0.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M57.831 48.001L55.6441 45.777C55.6441 45.777 54.5981 45.0034 53.9325 45.0034H51.1751C50.0341 45.0034 48.9881 44.52 48.2275 43.6497L42.9027 38.2348C41.9519 37.2678 41.7617 35.9141 42.4273 34.8505C42.8076 34.2703 43.3781 33.8835 43.9487 33.7868M43.9487 33.7868L38.9891 28.6647C38.1334 27.7945 38.0383 26.5374 38.7039 25.5705C39.0842 24.9903 39.7498 24.7002 40.4154 24.6035C41.081 24.6035 41.7466 24.7969 42.222 25.2804L47.9422 31.176C48.0373 30.6926 48.4176 30.2091 48.798 29.919C49.2734 29.5322 49.939 29.4355 50.6046 29.5322C50.6046 28.8554 50.9849 28.2752 51.5554 27.7917C52.0308 27.4049 52.6964 27.3082 53.2669 27.4049C53.2669 26.6314 53.6473 25.9545 54.2178 25.5677C55.0735 24.8908 56.4047 25.0842 57.2605 25.8578L61.254 29.919C62.0147 30.6926 62.5852 31.6595 62.9655 32.7232L63.7262 34.9472C64.0115 35.8174 64.4869 36.591 65.1525 37.2678L66.9591 39.105M43.9487 33.7868C48.3437 37.6976 49.2836 39.1439 51.5554 39.1439"
        stroke="#1A1A1A"
        stroke-linecap="round"
      />
      <path
        d="M57.831 48.001L55.6441 45.777C55.6441 45.777 54.5981 45.0034 53.9325 45.0034H51.1751C50.0341 45.0034 48.9881 44.52 48.2275 43.6497L42.9027 38.2348C41.9519 37.2678 41.7617 35.9141 42.4273 34.8505C42.8076 34.2703 43.3781 33.8835 43.9487 33.7868M43.9487 33.7868L38.9891 28.6647C38.1334 27.7945 38.0383 26.5374 38.7039 25.5705C39.0842 24.9903 39.7498 24.7002 40.4154 24.6035C41.081 24.6035 41.7466 24.7969 42.222 25.2804L47.9422 31.176C48.0373 30.6926 48.4176 30.2091 48.798 29.919C49.2734 29.5322 49.939 29.4355 50.6046 29.5322C50.6046 28.8554 50.9849 28.2752 51.5554 27.7917C52.0308 27.4049 52.6964 27.3082 53.2669 27.4049C53.2669 26.6314 53.6473 25.9545 54.2178 25.5677C55.0735 24.8908 56.4047 25.0842 57.2605 25.8578L61.254 29.919C62.0147 30.6926 62.5852 31.6595 62.9655 32.7232L63.7262 34.9472C64.0115 35.8174 64.4869 36.591 65.1525 37.2678L66.9591 39.105M43.9487 33.7868C48.3437 37.6976 49.2836 39.1439 51.5554 39.1439"
        stroke="black"
        stroke-opacity="0.2"
        stroke-linecap="round"
      />
      <path
        d="M57.831 48.001L55.6441 45.777C55.6441 45.777 54.5981 45.0034 53.9325 45.0034H51.1751C50.0341 45.0034 48.9881 44.52 48.2275 43.6497L42.9027 38.2348C41.9519 37.2678 41.7617 35.9141 42.4273 34.8505C42.8076 34.2703 43.3781 33.8835 43.9487 33.7868M43.9487 33.7868L38.9891 28.6647C38.1334 27.7945 38.0383 26.5374 38.7039 25.5705C39.0842 24.9903 39.7498 24.7002 40.4154 24.6035C41.081 24.6035 41.7466 24.7969 42.222 25.2804L47.9422 31.176C48.0373 30.6926 48.4176 30.2091 48.798 29.919C49.2734 29.5322 49.939 29.4355 50.6046 29.5322C50.6046 28.8554 50.9849 28.2752 51.5554 27.7917C52.0308 27.4049 52.6964 27.3082 53.2669 27.4049C53.2669 26.6314 53.6473 25.9545 54.2178 25.5677C55.0735 24.8908 56.4047 25.0842 57.2605 25.8578L61.254 29.919C62.0147 30.6926 62.5852 31.6595 62.9655 32.7232L63.7262 34.9472C64.0115 35.8174 64.4869 36.591 65.1525 37.2678L66.9591 39.105M43.9487 33.7868C48.3437 37.6976 49.2836 39.1439 51.5554 39.1439"
        stroke="black"
        stroke-opacity="0.2"
        stroke-linecap="round"
      />
      <path
        d="M57.831 48.001L55.6441 45.777C55.6441 45.777 54.5981 45.0034 53.9325 45.0034H51.1751C50.0341 45.0034 48.9881 44.52 48.2275 43.6497L42.9027 38.2348C41.9519 37.2678 41.7617 35.9141 42.4273 34.8505C42.8076 34.2703 43.3781 33.8835 43.9487 33.7868M43.9487 33.7868L38.9891 28.6647C38.1334 27.7945 38.0383 26.5374 38.7039 25.5705C39.0842 24.9903 39.7498 24.7002 40.4154 24.6035C41.081 24.6035 41.7466 24.7969 42.222 25.2804L47.9422 31.176C48.0373 30.6926 48.4176 30.2091 48.798 29.919C49.2734 29.5322 49.939 29.4355 50.6046 29.5322C50.6046 28.8554 50.9849 28.2752 51.5554 27.7917C52.0308 27.4049 52.6964 27.3082 53.2669 27.4049C53.2669 26.6314 53.6473 25.9545 54.2178 25.5677C55.0735 24.8908 56.4047 25.0842 57.2605 25.8578L61.254 29.919C62.0147 30.6926 62.5852 31.6595 62.9655 32.7232L63.7262 34.9472C64.0115 35.8174 64.4869 36.591 65.1525 37.2678L66.9591 39.105M43.9487 33.7868C48.3437 37.6976 49.2836 39.1439 51.5554 39.1439"
        stroke="black"
        stroke-opacity="0.2"
        stroke-linecap="round"
      />
      <path
        d="M53.0156 24.0399C53.0156 13.2896 44.2961 4.52148 33.5664 4.52148C22.8366 4.52148 14.1172 13.2653 14.1172 24.0399C14.1172 34.8146 22.8366 43.5827 33.5664 43.5827C35.711 43.5827 37.8123 43.2302 39.8048 42.5493"
        stroke="#1A1A1A"
        stroke-linecap="round"
      />
      <path
        d="M53.0156 24.0399C53.0156 13.2896 44.2961 4.52148 33.5664 4.52148C22.8366 4.52148 14.1172 13.2653 14.1172 24.0399C14.1172 34.8146 22.8366 43.5827 33.5664 43.5827C35.711 43.5827 37.8123 43.2302 39.8048 42.5493"
        stroke="black"
        stroke-opacity="0.2"
        stroke-linecap="round"
      />
      <path
        d="M53.0156 24.0399C53.0156 13.2896 44.2961 4.52148 33.5664 4.52148C22.8366 4.52148 14.1172 13.2653 14.1172 24.0399C14.1172 34.8146 22.8366 43.5827 33.5664 43.5827C35.711 43.5827 37.8123 43.2302 39.8048 42.5493"
        stroke="black"
        stroke-opacity="0.2"
        stroke-linecap="round"
      />
      <path
        d="M53.0156 24.0399C53.0156 13.2896 44.2961 4.52148 33.5664 4.52148C22.8366 4.52148 14.1172 13.2653 14.1172 24.0399C14.1172 34.8146 22.8366 43.5827 33.5664 43.5827C35.711 43.5827 37.8123 43.2302 39.8048 42.5493"
        stroke="black"
        stroke-opacity="0.2"
        stroke-linecap="round"
      />
      <path
        d="M33.5995 6.7793C36.1137 6.7793 38.5033 7.32068 40.6581 8.29258M30.2113 7.11301C27.2197 7.71066 24.5062 9.08413 22.2906 11.0144C21.3248 11.8558 20.4537 12.803 19.6953 13.8379"
        stroke="#1A1A1A"
        stroke-linecap="round"
      />
      <path
        d="M33.5995 6.7793C36.1137 6.7793 38.5033 7.32068 40.6581 8.29258M30.2113 7.11301C27.2197 7.71066 24.5062 9.08413 22.2906 11.0144C21.3248 11.8558 20.4537 12.803 19.6953 13.8379"
        stroke="black"
        stroke-opacity="0.2"
        stroke-linecap="round"
      />
      <path
        d="M33.5995 6.7793C36.1137 6.7793 38.5033 7.32068 40.6581 8.29258M30.2113 7.11301C27.2197 7.71066 24.5062 9.08413 22.2906 11.0144C21.3248 11.8558 20.4537 12.803 19.6953 13.8379"
        stroke="black"
        stroke-opacity="0.2"
        stroke-linecap="round"
      />
      <path
        d="M33.5995 6.7793C36.1137 6.7793 38.5033 7.32068 40.6581 8.29258M30.2113 7.11301C27.2197 7.71066 24.5062 9.08413 22.2906 11.0144C21.3248 11.8558 20.4537 12.803 19.6953 13.8379"
        stroke="black"
        stroke-opacity="0.2"
        stroke-linecap="round"
      />
      <path
        d="M0.829087 21.9264L2.90146 21.5395M4.44077 16.6566L4.82769 18.7289M7.6383 20.6551L9.71067 20.2682M5.71208 23.4657L6.099 25.5381"
        stroke="#1A1A1A"
        stroke-linecap="round"
      />
      <path
        d="M0.829087 21.9264L2.90146 21.5395M4.44077 16.6566L4.82769 18.7289M7.6383 20.6551L9.71067 20.2682M5.71208 23.4657L6.099 25.5381"
        stroke="black"
        stroke-opacity="0.2"
        stroke-linecap="round"
      />
      <path
        d="M0.829087 21.9264L2.90146 21.5395M4.44077 16.6566L4.82769 18.7289M7.6383 20.6551L9.71067 20.2682M5.71208 23.4657L6.099 25.5381"
        stroke="black"
        stroke-opacity="0.2"
        stroke-linecap="round"
      />
      <path
        d="M0.829087 21.9264L2.90146 21.5395M4.44077 16.6566L4.82769 18.7289M7.6383 20.6551L9.71067 20.2682M5.71208 23.4657L6.099 25.5381"
        stroke="black"
        stroke-opacity="0.2"
        stroke-linecap="round"
      />
      <path
        d="M53.9136 4.43784L55.9843 4.83365M59.199 0.848853L58.8031 2.91953M60.7173 5.73836L62.788 6.13416M57.8984 7.65249L57.5026 9.72316"
        stroke="#1A1A1A"
        stroke-linecap="round"
      />
      <path
        d="M53.9136 4.43784L55.9843 4.83365M59.199 0.848853L58.8031 2.91953M60.7173 5.73836L62.788 6.13416M57.8984 7.65249L57.5026 9.72316"
        stroke="black"
        stroke-opacity="0.2"
        stroke-linecap="round"
      />
      <path
        d="M53.9136 4.43784L55.9843 4.83365M59.199 0.848853L58.8031 2.91953M60.7173 5.73836L62.788 6.13416M57.8984 7.65249L57.5026 9.72316"
        stroke="black"
        stroke-opacity="0.2"
        stroke-linecap="round"
      />
      <path
        d="M53.9136 4.43784L55.9843 4.83365M59.199 0.848853L58.8031 2.91953M60.7173 5.73836L62.788 6.13416M57.8984 7.65249L57.5026 9.72316"
        stroke="black"
        stroke-opacity="0.2"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default CompleteIllustratorIcon;
